export default __webpack_public_path__ + "static/media/it-65.865bc021.svg";